import cx from 'classnames'
import { PressEvent } from '@react-types/shared/src/events'

import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { Tooltip } from 'components/Tooltip/Tooltip'

import Styles from './Action.module.scss'
import { Shimmerer } from 'blaze-ui/Shimmerer'
import { Icon } from 'almanac-ui/icons/Types'

export interface ActionProps extends Omit<ButtonProps, 'onClick'> {
  label: string
  tooltip?: string
  icon?: Icon
  iconColor?: string
  upgradeBadge?: React.ReactNode
}

export const Action = ({
  label,
  tooltip,
  icon: Icon,
  iconColor,
  isDisabled: propsIsDisabled,
  upgradeBadge,
  onPress,
  className,
  ...props
}: ActionProps) => {
  const isDisabled = propsIsDisabled

  const handlePress = (e: PressEvent) => {
    if (isDisabled) return

    onPress?.(e)
  }

  return (
    <Tooltip label={tooltip} placement="top" className={Styles.actionTooltip} hide={!tooltip}>
      {/* NOTICE: I hate this extra div too but the tooltip won't show for disable buttons otherwise
                  and we care to say why they are disabled */}
      <div className={Styles.actionWrapper}>
        <Shimmerer variant="secondary">
          <Button
            className={cx(Styles.action, className, {
              [Styles.disabled]: isDisabled,
            })}
            aria-label={label}
            variant="tertiary"
            onPress={handlePress}
            isDisabled={isDisabled}
            size={!!Icon ? 'xl' : 'lg'}
            {...props}
            frontIcon={() => {
              if (!Icon) return null
              return (
                <div className={Styles.icon} style={{ backgroundColor: iconColor }}>
                  <Icon />
                </div>
              )
            }}
          >
            {label}
            {upgradeBadge && <div className={Styles.upgradeBadgeContainer}>{upgradeBadge}</div>}
          </Button>
        </Shimmerer>
      </div>
    </Tooltip>
  )
}
